import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({ url: "/auth/login", method: "POST", body }),
    }),
    register: builder.mutation({
      query: (body) => ({ url: "/auth/register", method: "POST", body }),
    }),
    verifyOtp: builder.mutation({
      query: (body) => ({ url: "/auth/verify-otp", method: "POST", body }),
    }),
    resendOtp: builder.mutation({
      query: (body) => ({ url: "/auth/resend-otp", method: "POST", body }),
    }),
    forgotPassword: builder.mutation({
      query: (body) => ({ url: "/auth/forgot-password", method: "POST", body }),
    }),
    forgotPasswordVerifyOtp: builder.mutation({
      query: (body) => ({ url: "/auth/forgot-password/verify-otp", method: "POST", body }),
    }),
    forgotPasswordReset: builder.mutation({
      query: (body) => ({ url: "/auth/forgot-password/reset", method: "POST", body }),
    }),
    forgotPasswordResendOtp: builder.mutation({
      query: (body) => ({ url: "/auth/forgot-password/resend-otp", method: "POST", body }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useVerifyOtpMutation,
  useResendOtpMutation,
  useForgotPasswordMutation,
  useForgotPasswordVerifyOtpMutation,
  useForgotPasswordResetMutation,
  useForgotPasswordResendOtpMutation,
} = authApi;
